import React from "react";
import { navigateTo, Link } from "gatsby-link";
import Bus from "../../utils/bus";
let BUS = new Bus();

class CartButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cartActive: this.updateCartIcon(),
      onBuyPage: false
    };
    this.updateCartIcon = this.updateCartIcon.bind(this);
    this.locationChanged = this.locationChanged.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    BUS.listen("UPDATE_CART", this.updateCartIcon);
    BUS.listen("ON_ROUTE_UPDATE", this.locationChanged);
    this.locationChanged();
  }

  locationChanged(event) {
    let path = window.location.pathname;
    if (path === "/buy") {
      this.setState({
        onBuyPage: true
      });
    } else {
      this.setState({
        onBuyPage: false
      });
    }
  }

  handleClick() {
    let path = window.location.pathname;
    if (path === "/buy") {
      window.history.go(-1);
    } else {
      navigateTo("/buy");
    }
  }

  updateCartIcon(event) {
    if (event) {
      if (event.detail.data.lineItems.length > 0) {
        return this.setState({ cartActive: true });
      } else {
        return this.setState({ cartActive: false });
      }
    }
  }

  render() {
    return (
      <button className="cart-icon" onClick={this.handleClick}>
        {!this.state.onBuyPage && (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.73 13.1">
            <path d="M11.54 7.48H4.61v.87H14a.61.61 0 0 1 .42.21.53.53 0 0 1 .17.41v.63c0 .3-.22.47-.59.52H3.47a.54.54 0 0 1-.42-.18.57.57 0 0 1-.21-.41V1.77H.62a.61.61 0 0 1-.45-.18.61.61 0 0 1-.17-.45V.55A.93.93 0 0 1 .21.14.56.56 0 0 1 .62 0H4a.61.61 0 0 1 .42.17.64.64 0 0 1 .17.45v1.15h9.53a.53.53 0 0 1 .41.17.61.61 0 0 1 .18.45.45.45 0 0 1 0 .24l-2.6 4.51a.53.53 0 0 1-.57.34zm.14 5.62a.92.92 0 0 1-1-1 .92.92 0 0 1 1-1 .92.92 0 0 1 1 1 .92.92 0 0 1-1 1zm-7.35 0a.92.92 0 0 1-1-1 .92.92 0 0 1 1-1 .94.94 0 0 1 1.08 1 .94.94 0 0 1-1.08 1z" />
          </svg>
        )}
        {this.state.onBuyPage && <div className="x">x</div>}
      </button>
    );
  }
}

export default CartButton;



// WEBPACK FOOTER //
// ./src/components/nav/cart-button.js